/* global HIVE_MODULES */
export default HIVE_MODULES;
